<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { IconSize } from '~/utils/icon'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const { size = 'md' } = defineProps<{
  icon: IconDefinition
  size?: IconSize
  title?: string
}>()

const titleId = useId()
</script>

<template>
  <FontAwesomeIcon
    :icon
    :title
    :title-id="title ? titleId : undefined"
    :class="mergeClass(iconVariants({ size }), $attrs.class as string | undefined)"
  />
</template>
